import Vue from "vue";
import VueRouter from "vue-router";

import auth from "@/utils/auth";
import { NativeApp } from "./";
import Android, { isAndroid } from "./android";
import { BaseNativeApp } from "./baseNativeApp";
import IOS, { isIOS } from "./ios";
import Web from "./web";

export interface NativeAppOptions {
  router: VueRouter;
}

export default function install(vue: typeof Vue, options: NativeAppOptions) {
  // Determine the native app being used, if it isn't iOS or Android, default to a no-op
  let nativeApp: BaseNativeApp;
  if (isIOS()) {
    nativeApp = new IOS(options.router, auth);
  } else if (isAndroid()) {
    nativeApp = new Android(options.router, auth);
  } else {
    nativeApp = new Web(options.router, auth);
  }

  // Register the native app so that it can communicate with Vue.js
  nativeApp.register();
  // Make the native app available to Vue (wrap it in an observable so that changes are automatically reflected in Vue)
  vue.prototype.$nativeApp = Vue.observable(nativeApp as NativeApp);
}
